export default __webpack_public_path__ + "static/media/contactus.c0d6a40f.svg";